import filterFrequency from "../lib/filterFrequency"
import { DVBCHistoryMapping } from "../lib/rfMapping"
import { FrequenciesFilterState } from "../lib/types"
import dvbcMapper from './redux/mapper'
import { DVBCHistory, FrequencyLimitsType } from "./redux/types"

function isDvbcHistoryHealthy(historyEntry: DVBCHistory, filter: FrequenciesFilterState, frequencyLimits: FrequencyLimitsType){
  const dvbc = dvbcMapper(historyEntry.dvbc || [])
  const mappedFrequencies = DVBCHistoryMapping(dvbc, frequencyLimits)
  const filteredFrequencies = filterFrequency(mappedFrequencies, filter)

  return filteredFrequencies.every((row) => row.BERPO.isHealthy && row.PWR.isHealthy)
}

export function checkIsGroupHealthy(historyGroup: DVBCHistory[], filter: FrequenciesFilterState, frequencyLimits: FrequencyLimitsType) {
  return historyGroup.every((historyEntry) => isDvbcHistoryHealthy(historyEntry, filter, frequencyLimits))
}

export function checkIsEntryHealthy(historyEntry: DVBCHistory, filter: FrequenciesFilterState, frequencyLimits: FrequencyLimitsType) {
  return isDvbcHistoryHealthy(historyEntry, filter, frequencyLimits)
}
